<template>
<div id="Vue"  style="background:#eceaea;">

 
  
 
<el-row  type="flex" justify="center">   
<el-col :span="20" >
 
  
    
  <el-row id="customData" style="padding:10px; background: #fff;margin-top:20px " type="flex" justify="center" :gutter="20"  >	
  <el-col :span="8" :offset="2" > 
 
       
 
  <el-card   shadow="hover" style="margin-right: 1px; height:580px;" >
       
  
		<div style="padding: 2px;display:flex;flex-direction:column;margin-left:20px">
		<span   style="text-align:center;font-size:20px;color:#111">免费用户</span>  
		<br/>
		
		<span style="text-align:center;font-size:16px;color:#111"> 0元/年 </span> 
		
		<br/>
		
		<span   style="text-align:center;font-size:15px;color:#909399">包含以下功能: </span>
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 查询首页贸易数据 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 按HS-code,产品描述,采供商多维度查阅 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 查阅采供商公司报告 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 邮箱验证 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 公司决策者搜索 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> chatGPT免费提问10次 </span> 
		</div>
 
    </el-card> 
  </el-col>
  <el-col :span="8" :offset="2" > 
  <el-card   shadow="hover" style="  height:580px;"  >
       
  
		<div style="padding: 2px;display:flex;flex-direction:column;margin-left:20px">
		<span   style="text-align:center;font-size:20px;color:#111">VIP用户</span>  
		<br/>
		<span  style="text-align:center;font-size:16px;color:#111"> 68元/月 </span> 
		<span  style="text-align:center;font-size:16px;color:#111"> 698元/年 </span> 
		<br/>
		
		<span   style="text-align:center;font-size:15px;color:#909399">包含以下功能: </span>
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 查询全球各大贸易国贸易数据 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 按HS-code,产品描述,采供商多维度查阅 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 查阅采供商公司报告 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 查阅历届广交会采购商数据并下载 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 查阅世界各国公司数据及联系方式 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 邮箱验证 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> 公司决策者搜索 </span> 
		<span   style="text-align:center;font-size:15px;color:#909399"><i class="el-icon-check"></i> chatGPT任意搜索 </span> 
		
		<br/><br/><br/>
		<span   style="text-align:center;font-size:15px;color:#909399">
		  <el-button type="primary" icon="el-icon-sell" @click="upgrade" style="width:150px;text-align:center;">购买</el-button>  
		</span> 
		
		</div>
 
    </el-card>  
     
  </el-col> 
  </el-row>
   
 
</el-col>
</el-row>
	
 
	
</div>
</template>
<style>
  .el-col {
    border-radius: 4px;
  }
  .time {
    font-size: 13px;
    color: #999;
  }
  
  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }


 
</style>

<script>
 
export default {
 
        data () {
            return {
	    	is_loading: false,
		    userInfo: {},
			customShow : true,
			erpShow: false,
			amount: 0, 
			sk_id: 0,
			sk_name: '', 
			pay_mode: 'ali',
			tableData: [],
			} 
        },
        methods: { 

		  upgrade(){
			       this.$router.push({
					name: 'payment',
				    });
		  },
 
		},
	    created(){ },
		}
</script>
 


// WEBPACK FOOTER //
// src/components/customs/feature.vue